// @ts-nocheck
import * as types from '../types';
import { formatKycLogsData, formatLogsData } from '../../utils/render';
import { setPagination } from './pagination';
import { LOG_SERVICE_NAMES, PAGINATION_KEYS } from '../../utils/constants';

export const changeLogsDetails = details => ({
    type: types.LOGS_DETAILS_CHANGED,
    payload: details,
});

export const changeLogs = logs => ({
    type: types.LOGS_CHANGED,
    payload: logs,
});

export const changeOperationLogs = logs => ({
    type: types.OPERATION_LOGS_CHANGED,
    payload: logs,
});

export const clearLogs = () => ({
    type: types.LOGS_CLEARED,
});

export const getOperationLogs =
    ({ fetchData, query }) =>
    async dispatch => {
        dispatch(
            setPagination(PAGINATION_KEYS.operationLogs, {
                isFetching: true,
            }),
        );

        const { info, items } = await fetchData({ query });

        if (!info.success) {
            dispatch(
                setPagination(PAGINATION_KEYS.operationLogs, {
                    isFetching: false,
                }),
            );
            return;
        }

        const hasMore = items.length >= query.limit;

        dispatch(
            setPagination(PAGINATION_KEYS.operationLogs, {
                page: query.offset,
                limit: query.limit,
                hasMore,
                isFetching: false,
            }),
        );

        dispatch(changeOperationLogs(items));
    };

export const getLogs =
    ({ fetchData, query }) =>
    async dispatch => {
        dispatch(
            setPagination(PAGINATION_KEYS.logs, {
                isFetching: true,
            }),
        );

        const { info, items } = await fetchData({ query });

        if (!info.success) {
            dispatch(
                setPagination(PAGINATION_KEYS.logs, {
                    isFetching: false,
                }),
            );
            return;
        }

        const hasMore = items.length >= query.size;

        dispatch(
            setPagination(PAGINATION_KEYS.logs, {
                page: query.index,
                size: query.size,
                hasMore,
                isFetching: false,
            }),
        );

        let newLogsData;

        if (query.operation === LOG_SERVICE_NAMES.kycDocumentOperationStatus) {
            newLogsData = formatKycLogsData(items, LOG_SERVICE_NAMES.kycDocumentOperationStatus);
        } else if (query.operation === LOG_SERVICE_NAMES.playerDetailsUpdate) {
            newLogsData = formatKycLogsData(items, LOG_SERVICE_NAMES.playerDetailsUpdate);
        } else if (query.operation === LOG_SERVICE_NAMES.selfExclusion) {
            newLogsData = formatKycLogsData(items, LOG_SERVICE_NAMES.selfExclusion);
        } else {
            newLogsData = formatLogsData(items);
        }
        dispatch(changeLogs(newLogsData));
    };
